import React from 'react';

import useFeatureFlag from '../../../hooks/useFeatureFlags';
import Legacy from './Legacy';
import New from './New';

const TextEditor = (props) => {
  const isNewRichTextEditorEnabled = useFeatureFlag('newRichTextEditor');

  return isNewRichTextEditorEnabled ? (
    <New {...props} />
  ) : (
    <Legacy {...props} />
  );
};

export default TextEditor;
